<template>
	<div class="login">
		<div class="cross">
			<a class="link" onclick="window.history.go(-1);">
			<img :src="require('@/assets/cross.png')"/>
			</a>
		</div>
			
		<div class="container-phone" style="padding: 10vh 0;">

			<div class="logo" id="eximuslogin">
				<img :src="require('@/assets/logo_white_small.png')"/>
			</div>

			<div class="pad-l">
				<div class="f-l f-bold c-primary" style="margin: 1em 0">Login</div>
				
				<div style="margin-top: 0.5em;">
					<form class="form" @submit.prevent="doLogin">
						<div class="p-relative">
							<input type="text" class="text-input" v-model="login" name="login" placeholder="Email" autocomplete="username" required/>
							<div class="icon-md input-icon">email</div>
						</div>

						<div class="p-relative">
							<input type="password" class="text-input" v-model="password" name="password" placeholder="●●●●●●●●" autocomplete="current-password" required/>
							<div class="icon-md input-icon">lock</div>
						</div>

						<div class="t-right">
							<router-link class="reset-link" to="/reset-password">Dimenticata la Password?</router-link>
						</div>
						<br>
						<div style="margin: 0.5em 0;">
								<button type="input" class="submit-button">
									<LoadingWidget class="loading" :class="{hidden: !bLoading}"/>
									<span :class="{hidden: bLoading}">Sign In</span>
								</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { notif } from '@/pop'

export default {
	name: 'login',

	data() {

		return {
			// Account email
			login: '',

			// User password
			password: '',

			// Loading flag
			bLoading: false
		}
	},

	mounted() {

		window.scrollTo(0, 0)
	},

	methods: {
		/**
		 * Attempt login using credentials
		 */
		async doLogin() {
			
			this.bLoading = true

			try
			{
				let session = await this.$store.dispatch('auth/login', {
					login: this.login,
					password: this.password
				})

				// Redirect authenticated user
				notif.done(`Ciao ${session.user.first_name}`)
				this.$router.push(this.$route.query.redirect_url || '/me')
			}
			catch (err)
			{
				console.error(err.dev_msg || err)
				notif.error(err.display_msg || err)
			}
			finally
			{
				this.bLoading = false
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.cross
	position fixed
	right 20px
	margin-top 20px
	cursor pointer
	transition 0.4s ease
	z-index 9999

.cross img 
		width 1.4em

.logo
	width 144px

	margin 0 auto

	>img
		width 100%

		display block

.form
	.text-input
		width 100%

		display block

		margin 0.5em 0
		padding 0.4em 0.6em
		border none
		outline-color primary
		box-sizing border-box

		background-color dark
		color lightish

		font-size 1.1em

		&:focus
			color light
	
	.input-icon
		position absolute
		right 0.6em
		top 0.4em

		font-size 1.1em
	
	.reset-link
		color cadetblue

		text-decoration none

		&:hover
			text-decoration underline
	
	.submit-button
		width 100%

		display block

		position relative

		padding 0.4em 0.6em
		border none

		background-color primary
		color dark

		font-size: 1.2em

		transition height 0.2s ease

		&:hover
			background-color darken(primary, 2.5)

			cursor pointer
		&:focus
			outline none

		.loading
			width 1.8em
			height 1.8em

			position absolute
			top 50%
			left 50%

			color darkish

			transform translate(-50%, -50%)

			opacity 1

			transition 0.15s ease
		
			&.hidden
				opacity 0
		
		>span
			opacity 1

			transition 0.15s ease

			&.hidden
				opacity 0
</style>